import {Injectable} from '@angular/core';
import {BaseModalComponent} from './base-modal.component';
import {LeModalOptions} from './le-modal.options';
import {LeModalRef} from './le-modal-ref.service';
import {Subject} from "rxjs";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {NgbModalOptions} from "@ng-bootstrap/ng-bootstrap/modal/modal-config";
import {filter} from "rxjs/operators";

@Injectable()
export class LeModalService {
  logout$: Subject<boolean> = new Subject<boolean>();
  constructor(public bsModalService: NgbModal) {
    this.logout$.pipe(filter(logout => logout === true)).subscribe(() => this.bsModalService.dismissAll());
  }

  dismissAll(reason?: any) {
   return this.bsModalService.dismissAll(reason);
  }

  open(content: any, options?: NgbModalOptions): NgbModalRef{
    return this.bsModalService.open(content, options);
  }

  show<T extends BaseModalComponent>(
    content: (new(...args: any[]) => T),
    config?: LeModalOptions<T>
  ): LeModalRef<T> {
    config = config || {};
    config.ignoreBackdropClick = config.ignoreBackdropClick === undefined ? true : config.ignoreBackdropClick;

    const options: NgbModalOptions = {
      modalDialogClass: config.modalDialogClass ?? config.class,
      backdrop: config.ignoreBackdropClick === true ? "static" : true,
      keyboard: config.keyboard,
      scrollable: config.scrollable,
    }

    const modalRef: NgbModalRef = this.bsModalService.open(content, options);
    Object.assign(modalRef.componentInstance, config.initialState);
    return new LeModalRef<T>(modalRef);
  }
}
